import { queryOptions, useQuery } from '@tanstack/react-query';

import { BestPracticeCheckStandard } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

type UseBestPracticeCheckQuery = {
  clusterId?: string;
  ruleId?: string;
  standard?: BestPracticeCheckStandard;
};

const SECURITY_BEST_PRACTICE_CHECK_QUERY_KEY = 'security-best-practice-check';

const getBestPracticeCheckQueryKey = ({
  clusterId,
  ruleId,
  standard,
}: UseBestPracticeCheckQuery) => {
  const key = [SECURITY_BEST_PRACTICE_CHECK_QUERY_KEY, ruleId];

  if (clusterId !== undefined) {
    key.push(clusterId);
  }
  if (standard !== undefined) {
    key.push(standard);
  }

  return key;
};

const getBestPracticeCheckQueryOptions = ({
  clusterId,
  ruleId,
  standard,
}: UseBestPracticeCheckQuery) =>
  queryOptions({
    queryKey: getBestPracticeCheckQueryKey({ clusterId, ruleId, standard }),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getBestPracticeCheck({
        ruleId: ruleId!,
        standard,
      });
      return data;
    },
    enabled: !!ruleId,
    refetchInterval: false,
  });

export const useBestPracticeCheckQuery = (
  params: UseBestPracticeCheckQuery = {}
) => {
  const {
    isLoading,
    data: check,
    error,
    refetch,
  } = useQuery(getBestPracticeCheckQueryOptions(params));

  return { isLoading, check, error, refetch };
};
